import React from "react"
import Img from "gatsby-image"
import { StaticQuery, graphql } from "gatsby"
import { withTheme } from "emotion-theming"
import VisuallyHidden from "@reach/visually-hidden"

import { ViewButton } from "@components/button"
import { Container, Row, Col } from "@components/grid"
import Infographic from "@components/infographic"
import { KeylineDash } from "@components/keyline"
import Panel from "@components/panel"
import { Pullquote, Caption } from "@components/type"

import { Car, Carrot, Lights, Utensils } from "@svgs"

const sectionTitle = "Emergency Food Department"

const Emergency = ({ theme }) => {
  const border = `3px dashed ${theme.colours.secondary}`
  return (
    <section>
      <Panel maxWidth="1200px" background={theme.colours.primary}>
        <h1>{sectionTitle}</h1>
        <Panel background={theme.backgroundColor}>
          <h2>Our Community Impact</h2>
          <Caption>Impact of your donation</Caption>
          <Pullquote colour={theme.colours.primary}>
            For every $ donated to Neighbour to Neighbour, we can distribute $11
            worth of food in the community.
          </Pullquote>
          <Row>
            <Col
              width={[1, 1, 1 / 2]}
              style={{
                borderRight: border,
                marginBottom: 0,
              }}
            >
              <Infographic
                icon={<Carrot />}
                value="Food Collected"
                colour={theme.colours.secondary}
              >
                <strong>926,976</strong> Pounds of food collected
                <br />
                <strong> 36%</strong> Is produce, meat and dairy food collected
                valued at <strong>$2,410,130 </strong>
                <br />
                <strong>2,325</strong> Pounds of food donated to the Community
                Food Centre
              </Infographic>
            </Col>
            <Col width={[1, 1, 1 / 2]}>
              <Infographic
                icon={<Utensils />}
                value="People Served"
                colour={theme.colours.danger}
              >
                <strong>13,825</strong> Units of service <br />
                <strong>1,152</strong> Families per month <br />
                <strong>9,089</strong> Individuals <br />
                <strong>23,464</strong> Families served since 1986
                <br />
                <strong>8%</strong> Of clients are seniors
              </Infographic>
            </Col>
          </Row>
          <KeylineDash colour={theme.colours.secondary} />
          <Row>
            <Col width={[1, 1, 1 / 2]} style={{ borderRight: border }}>
              <Infographic
                icon={<Lights />}
                value="Christmas Market  Program"
                colour={theme.colours.success}
              >
                <strong>1,450</strong> Households attended our Christmas Market
                which ensures milk, eggs, meat and <strong>3</strong> vegetables
                to every household in addition to non-perishables
              </Infographic>
            </Col>
            <Col width={[1, 1, 1 / 2]}>
              <Infographic
                icon={<Car />}
                value="Home Delivery"
                colour={theme.colours.primary}
              >
                <strong>481</strong> Home Deliveries were made to clients who
                are unable to access our food bank due to medical challenges.
              </Infographic>
            </Col>
          </Row>
          <ViewButton
            to="/emergency-food-services"
            colour={theme.colours.primary}
          >
            View
            <VisuallyHidden> {sectionTitle}</VisuallyHidden>
          </ViewButton>
        </Panel>
        <StaticQuery
          query={graphql`
            query {
              file(relativePath: { eq: "home/girls-food.jpg" }) {
                childImageSharp {
                  fluid(maxWidth: 930) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          `}
          render={data => (
            <Container maxWidth="930px">
              <Img fluid={data.file.childImageSharp.fluid} />
            </Container>
          )}
        />
      </Panel>
    </section>
  )
}

export default withTheme(Emergency)
